import React, { useEffect, useState } from "react";

const SSOBridge = () => {
  const [error, setError] = useState(null);

  useEffect(() => {
    const authorizeUrl = localStorage.getItem("sso_authorize_url");
    localStorage.removeItem("sso_authorize_url");

    if (authorizeUrl) {
      window.location.href = authorizeUrl;
    } else {
      setError("Missing authorization URL. Please close this window and try again.");
    }
  }, []);

  if (error) {
    return (
      <div className="p-8 text-center">
        <p className="text-red-600">{error}</p>
        <button
          onClick={() => window.close()}
          className="mt-4 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold text-sm px-6 py-2 rounded-md"
        >
          Close
        </button>
      </div>
    );
  }

  return (
    <div className="p-8 text-center">
      <h2 className="text-xl font-semibold">Syncing session...</h2>
      <p>Please wait while we redirect you.</p>
    </div>
  );
};

export default SSOBridge;
